<template>
  <div class="expired-account">
    <div class="expired-account">
      <i class="material-icons expired-account__icon">
        cancel
      </i>
      <span class="expired-account__title">
        {{ $t('ACCOUNT.STATUS.IS_EXPIRED') }}
      </span>

      <ElButton
        size="mini"
        type="primary"
        class="expired-account__extend-button"
        :loading="loading"
        @click.native="$emit('extend')"
      >
        {{ $t('ACCOUNT.STATUS.EXTEND_MEMBERSHIP') }}
      </ElButton>
    </div>
    <p class="expired-account__description">
      {{ $t('ACCOUNT.STATUS.IS_EXPIRED_DESC') }}
    </p>

    <p
      v-dompurify-html="$t('ACCOUNT.STATUS.SKIP_EXTENSION_PAY')"
      class="expired-account__description"
    />
  </div>
</template>

<script>
export default {
  name: 'ExpiredAccount',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.expired-account {
  &__icon {
    color: $lb-color-alert;
  }

  &__title {
    color: $lb-color-alert;
  }

  &__description {
    margin-top: $global-margin / 2;
    margin-bottom: 0;
    // to align with Expire icon
    margin-left: 3px;
    @include rtl() {
      margin-left: 0;
      margin-right: 3px;
    }
    font-size: rem-calc(13);
  }

  &__extend-button {
    margin-left: $global-margin;
    @include rtl() {
      margin-right: $global-margin;
      margin-left: 0;
    }
  }
}
</style>
